/* global axios */

import ApiClient from '../ApiClient';

class WhitelabAPI extends ApiClient {
  constructor() {
    super('integrations/whitelab', { accountScoped: true });
  }

  getPlayerContext(conversationId, { refresh = false } = {}) {
    return axios.get(`${this.url}/player_context`, {
      params: { conversation_id: conversationId, refresh },
    });
  }

  // Separate call on purpose. Whitelab returns the phone unmasked because agents
  // have to call players back, so it is withheld from the panel payload and
  // fetched only when an agent asks — which the server records as its own audit
  // event.
  getPlayerPhone(conversationId) {
    return axios.get(`${this.url}/player_phone`, {
      params: { conversation_id: conversationId },
    });
  }

  // Returns the IP and the moment it was recorded together. They are never sent
  // apart: an IP with no date beside it reads as a current location.
  getPlayerIp(conversationId) {
    return axios.get(`${this.url}/player_ip`, {
      params: { conversation_id: conversationId },
    });
  }

  get settingsUrl() {
    return this.url.replace(/whitelab$/, 'whitelab_settings');
  }

  getSettings() {
    return axios.get(this.settingsUrl);
  }

  // Deliberately sends nothing: the server tests the credential it has stored,
  // so an endpoint or key in this body would only be a way to make it call an
  // arbitrary host.
  testConnection() {
    return axios.post(`${this.settingsUrl}/test_connection`);
  }

  // Multipart only when a file is actually attached. Sending FormData for every
  // save would turn booleans and arrays into strings on the way in for no reason.
  updateSettings(settings, logoFile = null) {
    if (!logoFile) return axios.patch(this.settingsUrl, settings);

    const form = new FormData();
    Object.entries(settings).forEach(([key, value]) => {
      if (Array.isArray(value)) {
        // Rails needs the [] suffix to parse these back into an array, and an
        // empty array still has to be sent or the field is left untouched.
        if (!value.length) form.append(`${key}[]`, '');
        value.forEach(item => form.append(`${key}[]`, item));
      } else if (value !== null && value !== undefined) {
        form.append(key, value);
      }
    });
    form.append('logo', logoFile);
    return axios.patch(this.settingsUrl, form);
  }

  deleteSettings() {
    return axios.delete(this.settingsUrl);
  }
}

export default new WhitelabAPI();
